function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
var Input = React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      label = _ref.label,
      error = _ref.error,
      id = _ref.id,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? id : _ref$name,
      placeholder = _ref.placeholder,
      type = _ref.type,
      textarea = _ref.textarea,
      disabled = _ref.disabled,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "label", "error", "id", "name", "placeholder", "type", "textarea", "disabled"]);

  var Component = textarea ? 'textarea' : 'input';
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, label && /*#__PURE__*/React.createElement("label", {
    htmlFor: name,
    className: "sr-only"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "relative rounded-md shadow-sm"
  }, /*#__PURE__*/React.createElement(Component, _extends({
    id: name,
    name: name,
    ref: ref,
    type: type,
    disabled: disabled,
    className: "form-input block w-full py-3 px-4 placeholder-gray-500 transition ease-in-out duration-150 disabled:opacity-50 disabled:opacity-50",
    placeholder: placeholder
  }, props))), /*#__PURE__*/React.createElement("p", {
    className: "text-negative text-sm h-5"
  }, error));
});
Input.displayName = 'Input';
export default Input;